import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { types as actions, setZonesAction } from '../../reducers/actions';
import { ZoneService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_ZONES),
    switchMap(action =>
      forkJoin(
        of(action.areaId),
        ZoneService.getByAreaId(action.areaId, store)
      ).pipe(
        map(([areaId, data]) => setZonesAction(areaId, data)),
        catchError(retryAuthentication(action$, 'epics/zones/getZones'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/zones/getZones.js